import { aomGraphqlRequest } from '@root/src/core/utils/backend-service.ts';
import {
    mapUserPreferencesViewConfigFromAPIToModel,
    mapUserPreferencesViewConfigFromModelToAPI,
} from '@root/src/modules/global/mappers/user-preferences-view-fields.mapper.ts';
import {
    UserPreferencesViewConfig,
    UserPreferencesViewConfigFlat,
} from '@root/src/modules/global/model/user-preferences-view-fields.model.ts';
import { UserPreferencesViewConfigAPI } from 'modules/global/api/user-preferences-view-fields.api.ts';
import { getUserPreferencesColumns, saveUserPreferencesColumns } from './editable-column.queries';

export const saveEditColumnsConfig = (userPreferences: UserPreferencesViewConfigFlat): Promise<{ result: string }> =>
    aomGraphqlRequest(saveUserPreferencesColumns(), {
        userPreferences: mapUserPreferencesViewConfigFromModelToAPI(userPreferences),
    }).then(() => ({ result: 'ok' }));

export const getEditColumnsConfig = (): Promise<{ userPreferences: UserPreferencesViewConfig }> =>
    aomGraphqlRequest(getUserPreferencesColumns()).then((result) => ({
        userPreferences: mapUserPreferencesViewConfigFromAPIToModel(
            result.data.userPreferences as UserPreferencesViewConfigAPI
        ),
    }));
